import { render, staticRenderFns } from "./FieldColorPicker.vue?vue&type=template&id=5c62b53f&scoped=true"
import script from "./FieldColorPicker.vue?vue&type=script&lang=js"
export * from "./FieldColorPicker.vue?vue&type=script&lang=js"
import style0 from "./FieldColorPicker.vue?vue&type=style&index=0&id=5c62b53f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62b53f",
  null
  
)

export default component.exports